// Definición de defaults

export const defaultClaseDocumento: ClaseDocumentoProps = {
    idClaseDocumento: 0,
    descripcion:      '',
    activo:           false,
}

// Creación de interfaces

export interface ClaseDocumentoProps {
    idClaseDocumento:        number;
    descripcion:             string;
    activo:                  boolean;
}